// extracted by mini-css-extract-plugin
module.exports = {"grid":"_home_grid__18Qfv","image":"_home_image__etzb9","title":"_home_title__2moAO","company_logo":"_home_company_logo__2QMRE"};